exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-title .close-icon {\n  transform: scale(1.2);\n  margin-left: auto;\n  margin-top: 4px;\n  cursor: pointer; }\n\nmat-progress-bar {\n  top: -20px; }\n\n.mat-form-field .placeholder-color {\n  color: rgba(0, 0, 0, 0.42); }\n", ""]);

// exports
